import React from 'react';
import { DocumentStorageContextProvider } from 'framework/documentStorage';
import useAcceptanceDocumentsService from './useAcceptanceDocumentsService';

const AcceptanceDocumentContextTemplate = ({ children }: { children: React.ReactNode }) => {
  const actions = useAcceptanceDocumentsService();
  return <DocumentStorageContextProvider value={actions}>{children}</DocumentStorageContextProvider>;
};

export default AcceptanceDocumentContextTemplate;
